import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { setShowSearch } from "../../store/appConfigsSlice";

import { RefundRequestForm } from "../../components";

// Страница «Заявление о возврате»: доступна гостю (ссылка в футере) и авторизованному клиенту
// (кнопка в списке заказов / на странице заказа передаёт ?order_id=).
const RefundRequestPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, []);

  return <RefundRequestForm />;
};

export default withTranslation()(RefundRequestPage);
